import { isNil } from "lodash";
import qs from "qs";

export const TOGGLES = {
  LETTER_TRACK: "letterTrack",
  SECURE_FILES: "secureFiles",
};

/** Maps toggle query key → CRA env var (see .env.development / .env.production). */
const TOGGLE_ENV = {
  [TOGGLES.LETTER_TRACK]: "REACT_APP_LETTER_TRACK",
  [TOGGLES.SECURE_FILES]: "REACT_APP_SECURE_FILES",
};

export const getToggleEnabled = (toggle) => {
  const queryStringToggleValue = getQueryString(toggle);
  if (!isNil(queryStringToggleValue)) {
    return queryStringToggleValue !== "false";
  }
  const envName = TOGGLE_ENV[toggle];
  if (envName) {
    const v = process.env[envName];
    if (v === "true" || v === "1") return true;
    if (v === "false" || v === "0") return false;
  }
  return false;
};

export const getQueryString = (query) => {
  const queries = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  return queries[query];
};
